import './assets/styles/index.scss'
import { createApp, type App } from 'vue'
import AppComponent from './App.vue'
import router from './router'
import { useGlobal } from './global'
import { Analytics, UserType, ClientType, UploadMode } from '@/lib/lsj-analystics.esm.js'
import { BASE_DATA_CENTER } from './api/config'

// 埋点配置
const analyticsConfig = {
  enable: true,
  clientType: ClientType.WEB,
  // userId: 'demo-user-123',
  uploadMode: UploadMode.REALTIME,
  printLog: true,
  baseUrl: BASE_DATA_CENTER,
  userType: UserType.GUEST,
  // statisticPages,
  // uploadToServer: async (events) => {
  //   const eventList = Array.isArray(events) ? events : Object.values(events)
  //   console.log(`📊 [Analytics] 上传 ${eventList.length} 个事件`)
  //   console.log('📋 [Analytics] 事件详情:', eventList)
  //   // 模拟网络请求
  //   await new Promise(resolve => setTimeout(resolve, 300))
  //   const eventTypes = eventList.map(e => {
  //     const typeMap = { 0: '页面', 1: '功能', 2: '按钮' }
  //     return typeMap[e.logType] || '未知'
  //   })

  //   console.log(`✅ [Analytics] 上传成功: ${eventTypes.join(', ')}`)
  //   return { success: true, uploadId: `upload_${Date.now()}` }
  // }
}

// 路由追踪配置
const routerConfig = {
  enableAutoTracking: false,
  enableRouteLogging: import.meta.env.MODE === 'development',
  ignoreRoutes: ['/404', '/error']
}

/**
 * 初始化埋点系统
 */
async function initAnalytics(app: App<Element>) {
  try {
    const analytics = Analytics.getInstance()

    // 1. 初始化配置
    await analytics.init(analyticsConfig)
    console.log('✅ [Analytics] 配置初始化完成')

    // // 2. 注册 Vue 插件
    // app.use(LsjAnalyticsPlugin, {})
    // console.log('✅ [Analytics] Vue插件注册完成')

    // // 3. 设置路由追踪
    // const routerPlugin = setupRouterTracking(router, routerConfig)
    // console.log('✅ [Analytics] 路由追踪启用')

    // 4. 开发环境调试
    if (import.meta.env.MODE === 'development') {
      window.$analytics = analytics
      // window.$routerPlugin = routerPlugin
      console.log('🔧 [Analytics] 调试工具已暴露到 window')
    }

    // 5. 发送初始化事件
    // await analytics.batchPageEvent({
    //   routeName: 'app-init',
    //   functionId: EventIds.HOME_PAGE,
    //   remark: { source: 'app-startup' }
    // })

    console.log('🚀 [Analytics] 系统初始化完成')
    return { analytics }

  } catch (error) {
    console.error('❌ [Analytics] 初始化失败:', error)
    return null
  }
}

/**
 * 应用启动函数
 */
async function bootstrap() {
  console.log('🎯 [App] 开始启动应用...')

  try {
    // 创建 Vue 应用
    const app = createApp(AppComponent)

    // 注册插件
    app.use(router)
    // 初始化全局配置
    useGlobal()

    // 挂载应用
    app.mount('#app')
    console.log('✅ [App] Vue应用挂载完成')

    // 延迟初始化埋点系统，确保 Vue 完全就绪
    const analyticsResult = await initAnalytics(app)

    if (analyticsResult) {
      // 注册清理函数
      window.addEventListener('beforeunload', () => {
        try {
          // analyticsResult.routerPlugin?.cleanup?.()
        } catch (e) {
          console.warn('清理埋点资源时出错:', e)
        }
      })
    }

    console.log('🎉 [App] 应用启动完成!')

  } catch (error) {
    console.error('❌ [App] 应用启动失败:', error)

    // 降级启动：只启动基础应用
    console.log('🔄 [App] 尝试基础模式启动...')
    const fallbackApp = createApp(AppComponent)
    fallbackApp.use(router)
    fallbackApp.mount('#app')
    console.log('✅ [App] 基础模式启动完成')
  }
}

// 启动应用
bootstrap()
